module.exports = __webpack_public_path__ + "static/media/LockIcon.1377e925.svg";